var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommentIndicator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.95,
  d: "M2 3h16v11H2z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h20v20H0z",
  style: {
    mixBlendMode: "multiply"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 14h4v1H9zM9.38 15h3v1h-3zM9.38 16h2v1h-2zM9.38 17h2v1.13h-2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#525252",
  d: "M11.088 18.75 10 18.125l2.5-4.375h3.75a1.25 1.25 0 0 0 1.25-1.25V5a1.25 1.25 0 0 0-1.25-1.25H3.75A1.25 1.25 0 0 0 2.5 5v7.5a1.25 1.25 0 0 0 1.25 1.25h5.625V15H3.75a2.5 2.5 0 0 1-2.5-2.5V5a2.5 2.5 0 0 1 2.5-2.5h12.5a2.5 2.5 0 0 1 2.5 2.5v7.5a2.5 2.5 0 0 1-2.5 2.5h-3.025z"
})));
export default SvgCommentIndicator;